import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PostCard } from "./PostCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Home page strip: the 3 newest posts (pinned first)
export const LatestPosts = () => {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        axios.get(`${API}/posts`, { params: { limit: 3 } }).then(r => setPosts(r.data.posts)).catch(() => {});
    }, []);
    if (!posts.length) return null;
    return (
        <section className="py-16 px-4 bg-[#F5EDD6] border-t-2 border-[#3D2008]" data-testid="latest-posts-section">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-8 gap-2">
                    <div>
                        <span className="font-marker text-[#C4522A] text-2xl -rotate-1 inline-block mb-1">Fresh off the board</span>
                        <h2 className="font-anton text-4xl sm:text-5xl text-[#3D2008] uppercase leading-none">Latest from SLSA</h2>
                    </div>
                    <Link to="/whats-happening" data-testid="latest-posts-see-all" className="inline-flex items-center gap-1 py-2 font-manrope font-semibold text-[#C4522A] hover:text-[#3D2008] transition-colors">
                        See all <ArrowRight size={16} />
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {posts.map((p, i) => (
                        <Link key={p.id} to={`/whats-happening#post-${p.id}`} className="block hover:-translate-y-1 transition-transform duration-200">
                            <PostCard post={p} index={i} compact />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};
